module.exports = __webpack_public_path__ + "media/images/riders/small/EMILIE_SIEGENTHALER-b4582a8f7b1d00341e6851a47a4cff5b.png";